/**
 * External dependencies
 */
import { Reducer } from 'redux';
import produce from 'immer';

/**
 * Internal dependencies
 */
import Project from '@naruto/bgdcms//src/reducers/stores/project';
import PROJECT_ACTION from '@naruto/bgdcms//src/reducers/cores/project/events';
import { CreateProjectReducerParams, ProjectActionTypes } from './types';

export function createProjectReducer(params: CreateProjectReducerParams): Reducer<Project, ProjectActionTypes> {
  return (state = params.initialState, action: ProjectActionTypes): Project =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case PROJECT_ACTION.SET_PROJECT_INITIALIZE:
          draft.initialize();
          break;
        case PROJECT_ACTION.SET_PROJECT_LIST:
          draft.updateProjectList(action.list, action.condition);
          break;
        case PROJECT_ACTION.SET_PROJECT_INFO:
          draft.updateProjectInfo(action.projectID, action.projectInfo);
          break;
        default:
          break;
      }
    });
}
